import React from "react";
import styled from "styled-components";
import PartnershipImg from "../../../assets/images/logo/forall-logo.webp";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";

const Wrapper = styled.section`
  width: 100%;
  /* background-color: #f8f7f7; */
`;

const Container = styled.div`
  padding: 80px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
  box-sizing: border-box;

  @media (max-width: 950px) {
    padding: 50px 20px;
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  max-width: 300px;
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const InfoWrapper = styled.div`
  width: 100%;
  max-width: 45vw;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;

  @media (max-width: 950px) {
    max-width: 100%;
  }
`;

const Subtitle = styled.h3`
  font-weight: 400;
  color: ${colors.maroon};
  font-size: ${fontSize.s};
  letter-spacing: 0.04rem;
`;

const Heading = styled.h1`
  font-weight: 400;
  color: ${colors.maroon};
  font-size: ${fontSize.xl};
  letter-spacing: 0.1rem;
`;

const Paragraph = styled.p`
  letter-spacing: 0.04rem;
  line-height: 1.24rem;
  color: ${colors.black};
  font-size: ${fontSize.xs};
`;

function PartnershipSection() {
  return (
    <Wrapper>
      <Container>
        <InfoWrapper>
          <Subtitle>FORALL MANUFACTURING</Subtitle>
          <Heading>A THRIVING PARTNERSHIP</Heading>
          <Paragraph>
            In partnership with Forall Manufacturing our sister company, the
            rare fibers of the Himalayas are woven into cashmere of timeless
            beauty.
          </Paragraph>
        </InfoWrapper>
        <ImageWrapper>
          <Image src={PartnershipImg} alt="Suprabha Ojha portrait" />
        </ImageWrapper>
      </Container>
    </Wrapper>
  );
}

export default PartnershipSection;
